export default __webpack_public_path__ + "static/media/oh-snap.f09de691.png";